<script lang="ts" setup>
import { Button } from 'primevue'

import PvIcon from '@/components/ui/PvIcon.vue'
import { openAppStore, openPlayStore } from '@/constants/functions'

// `stacked` is the mobile-menu layout: one full-width button per row, matching
// the login button pinned in the drawer footer.
withDefaults(defineProps<{ stacked?: boolean }>(), { stacked: false })
</script>

<template>
  <div :class="stacked ? 'flex-col w-full' : 'flex-wrap'" class="flex justify-center gap-4">
    <Button :class="{ 'w-full': stacked }" class="p-button-website" outlined @click="openAppStore">
      <PvIcon class="w-5 h-5" name="apple" />
      App Store
    </Button>
    <Button :class="{ 'w-full': stacked }" class="p-button-website" outlined @click="openPlayStore">
      <PvIcon class="w-5 h-5" name="google-play" />
      Google Play
    </Button>
  </div>
</template>
